<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-dark sticky-top"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar"> </navbar-toggle-button>

      <!-- <slot name="mobile-right"> -->
      <ul class="nav align-items-center d-md-none">
        
      </ul>
      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-12 collapse-close">
              <navbar-toggle-button
                @click.native="closeSidebar"
              ></navbar-toggle-button>
            </div>
          </div>
        </div>

        <div class="top-logo d-flex align-items-center justify-content-center">
          <slot name="topLogo"></slot>
          <img
            v-if="company_logo"
            :alt="company_logo"
            :src="`${publicPath}/img/rcp/${company_logo}.png`"
            class="company-logo ml-2"
          />
        </div>

        <ul class="navbar-nav">
          <slot name="links"> </slot>
        </ul>
      </div>
      <div class="p-relative p-16 br-10 bg-type-card mt-50 d-none d-md-block" id="chat-with-us" v-if="chat">
        <div
          class="d-flex justify-content-center align-items-center flex-column"
        >
          <img :src="`${publicPath}/img/rcp/ask-icon.svg`" class="img-ask" />
          <div class="mt-30">
            <h1 class="blue-font fz-16 fw-700 ff-plus-jakarta-sans text-center">
              {{ $t("Customer Service") }}
            </h1>
            <p class="my-3 ff-inter fz-12 fw-400 text-center text-color-2D3135">
              {{$t("Having Trouble in {companyName}? Please contact us for more questions.",{companyName:companyName})}}
            </p>
          </div>
          <button class="btn btn-card-2" @click="navigateToCS">
            <span class="text-center fw-700 fz-12 ff-plus-jakarta-sans">{{
              $t("Chat with us")
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import NavbarToggleButton from "@/components/NavbarToggleButton";

export default {
  name: "sidebar",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      companyName:process.env.VUE_APP_COMPANY_NAME,
      company_logo: "",
      list_logo: JSON.parse(process.env.VUE_APP_COMPANY_LOGO),
      chat: process.env.VUE_APP_CHAT
    };
  },
  components: {
    NavbarToggleButton,
  },
  props: {
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    navigateToCS() {
      this.$router.push("/cs");
    },
    doLogout() {
      localStorage.removeItem("token");
      localStorage.removeItem("member");
      localStorage.removeItem("isFirstTime");
      window.parent.location.href =
        location.protocol + "//" + window.location.hostname;
    },
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
  },
  mounted() {
    const domain_url =
      process.env.VUE_APP_CURRENT_DOMAIN
        ? process.env.VUE_APP_CURRENT_DOMAIN
        : location.protocol + "//" + window.location.hostname;

    Object.keys(this.list_logo).forEach((key) => {
      if (domain_url.indexOf(key) != -1) {
        this.company_logo = this.list_logo[key];
      }
    });
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
